module.exports = __webpack_public_path__ + "static/media/jungwoo-6.jpeg";